import { render } from "./AddVpcOffering.vue?vue&type=template&id=0a5f9395&scoped=true"
import script from "./AddVpcOffering.vue?vue&type=script&lang=js"
export * from "./AddVpcOffering.vue?vue&type=script&lang=js"

import "./AddVpcOffering.vue?vue&type=style&index=0&id=0a5f9395&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5f9395"]])

export default __exports__